import { useStripe, useElements } from '@stripe/react-stripe-js';

import rootStore from '../../rootStore/RootStore';
import { Plan } from '../../../../shared/helpers/constants/plans';
import { getReturnUrl } from '../../../../shared/helpers/functions/navigation';
import { PricingPlan } from '../../../../shared/graphql/graphql';
import useUser from '../../../../shared/features/user/hooks/useUser';

export default function useStripePayment() {
  const stripe = useStripe();
  const elements = useElements();
  const { checkoutStore } = rootStore;
  const { customer } = useUser(rootStore);

  const validatePaymentInput = async () => {
    if (!stripe || !elements) {
      return {
        error: new Error(
          '[useStripePayment][validatePaymentInput] Stripe is not initialized',
        ),
      };
    }

    const { error } = await elements.submit();

    return error;
  };

  const confirmPayment = async (plan: Plan, clientSecret: string) => {
    if (!stripe || !elements) {
      return;
    }

    checkoutStore.setPaymentInProgress(true);

    let pricingPlan;
    let confirmIntent;

    if (plan === Plan.annual) {
      pricingPlan = PricingPlan.AnnualSubscription;
      confirmIntent = (...args: Parameters<typeof stripe.confirmPayment>) =>
        stripe.confirmPayment(...args);
    } else {
      pricingPlan = PricingPlan.MonthlyPayAsYouGo;
      confirmIntent = (...args: Parameters<typeof stripe.confirmSetup>) =>
        stripe.confirmSetup(...args);
    }

    const { error } = await confirmIntent({
      elements,
      clientSecret,
      confirmParams: {
        return_url: getReturnUrl(pricingPlan, customer?.id),
      },
    });

    if (error) {
      checkoutStore.setPaymentInProgress(false);
    }
  };

  return {
    confirmPayment,
    validatePaymentInput,
    paymentInProgress: checkoutStore.paymentInProgress,
  };
}
